import { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { BottomBar } from "../../components/bottom-bar";
import Button from "./../../components/button";
import { useUrlState } from "../../hooks";
import { StoreContextType } from "@/store/types";
import { Context } from "../../../../../store/store";
import { StaticIntroType } from "./../../types";
import { Module } from "../../../../../constants";
import { INTRO_SUB_URL, PERSONAL_SUMMARY_SUB_URL } from "../../../constants";
import { Category } from "../../../FuturebilityCockpit/types";
import { ReflectionType } from "../../../../../types";

import "./styles.scss";

export function StaticIntro() {
  const { t } = useTranslation();
  const { subPage, navigateToParticipationPage } = useUrlState();
  const [state] = useContext<StoreContextType>(Context as any);
  const { publicTest } = state;

  const introType = useMemo<StaticIntroType>(() => {
    return subPage as StaticIntroType;
  }, [subPage]);

  const htmlSnippet = useMemo(() => {
    switch (introType) {
      case StaticIntroType.Overall:
        return publicTest.introOverallHtml;
      case StaticIntroType.Instructions:
        return publicTest.introInstructionsHtml;
      case StaticIntroType.Organisation:
        return publicTest.introOrganizationHtml;
      case StaticIntroType.Team:
        return publicTest.introTeamHtml;
      case StaticIntroType.Leadership:
        return publicTest.introLeadershipHtml;
      case StaticIntroType.PersonalSummary:
        return publicTest.introPersonalSummaryHtml;
      case StaticIntroType.Leverages:
        return publicTest.introLeveragesHtml;
      case StaticIntroType.Challenges:
        return publicTest.introChallengesHtml;
      default:
        return "";
    }
  }, [introType, publicTest]);

  function navigateToAnalyticsTestSetCategory(category: Category) {
    const testSets = publicTest.sets.filter(ts => ts.category === category);
    const {
      info: { infoParticipation },
      _id: testSetId,
      items,
    } = testSets[0];

    navigateToParticipationPage({
      module: Module.Analytics,
      subPage: testSetId,
      subStep: infoParticipation ? INTRO_SUB_URL : items[0]._id,
    });
  }

  function navigateToReflectionTestSetCategory(type: ReflectionType) {
    const testSets = publicTest.reflectionTestSets.filter(
      ts => ts.info.type === type
    );
    const {
      info: { infoParticipation },
      _id: testSetId,
      items,
    } = testSets[0];

    navigateToParticipationPage({
      module: Module.Reflection,
      subPage: testSetId,
      subStep: infoParticipation ? INTRO_SUB_URL : items[0]._id,
    });
  }

  function handleNextClick() {
    if (introType === StaticIntroType.Overall) {
      navigateToParticipationPage({
        subPage: StaticIntroType.Instructions,
      });
    } else if (introType === StaticIntroType.Instructions) {
      navigateToParticipationPage({
        module: Module.Analytics,
        subPage: INTRO_SUB_URL,
      });
    } else if (introType === StaticIntroType.Organisation) {
      navigateToAnalyticsTestSetCategory(Category.Organization);
    } else if (introType === StaticIntroType.Team) {
      navigateToAnalyticsTestSetCategory(Category.Team);
    } else if (introType === StaticIntroType.Leadership) {
      navigateToAnalyticsTestSetCategory(Category.Leadership);
    } else if (introType === StaticIntroType.PersonalSummary) {
      navigateToParticipationPage({
        module: Module.Analytics,
        subPage: PERSONAL_SUMMARY_SUB_URL,
      });
    } else if (introType === StaticIntroType.Leverages) {
      navigateToReflectionTestSetCategory(ReflectionType.Leverage);
    } else if (introType === StaticIntroType.Challenges) {
      navigateToReflectionTestSetCategory(ReflectionType.Challenge);
    }
  }

  return (
    <div className="tg_page tg_page-layout tg_module_intro">
      <div className="tg_main tg_column">
        <div
          className="tg_info tg_test-welcome-html tg_test-info"
          dangerouslySetInnerHTML={{
            __html: htmlSnippet,
          }}
        />
      </div>
      <div className="tg_module-intro-actions tg_column">
        <Button onClick={handleNextClick} large>
          {t("frontend.test.nextTestSetButtonText")}
        </Button>
      </div>
      <BottomBar />
    </div>
  );
}
